<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Report Schedules] ' + report.report_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/reports">My Reports</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/reports/view/${report.id}`">{{ report.report_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Edit Automation Schedules
                    </li>
                </ol>
            </nav>

            <h4 class="page-header">
                <span class="text-muted">{{ report.report_name }}:</span> Edit Automation Schedules
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">

                    <div class="card mb-3" v-for="(schedule, i) in schedules">
                        <div class="card-header">
                            <button type="button" class="btn btn-sm btn-default" v-on:click="removeSchedule(i)" title="Remove Schedule"><i class="fa fa-times text-danger"></i></button>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.schedule_time'], 'text-muted-no': !errors['schedules.'+i+'.schedule_time']}">
                                    Delivery Time: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-12 input-group-sm">
                                    <b-form-timepicker v-model="schedule.schedule_time" size="sm" :minutes-step="15" :class="{'is-invalid': errors['schedules.'+i+'.schedule_time']}" />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.schedule_time']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.schedule_time']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-12 input-group-sm">
                                    <b-form-select v-model="schedule.timezone" size="sm" :options="timezoneOptions" :class="{'is-invalid': errors['schedules.'+i+'.timezone']}" />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.schedule_type'], 'text-muted-no': !errors['schedules.'+i+'.schedule_type']}">
                                    Frequency: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="schedule.schedule_type" size="sm" :options="scheduleTypeOptions" :class="{'is-invalid': errors['schedules.'+i+'.schedule_type']}" />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.schedule_type']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.schedule_type']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.is_active'], 'text-muted-no': !errors['schedules.'+i+'.is_active']}">
                                    Active:
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="schedule.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.is_active']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.is_active']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="schedule.schedule_type === 'Daily'">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.exclude_weekends'], 'text-muted-no': !errors['schedules.'+i+'.exclude_weekends']}">
                                    Exclude Weekends:
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="schedule.exclude_weekends" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.exclude_weekends']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.exclude_weekends']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.save_to_report'], 'text-muted-no': !errors['schedules.'+i+'.save_to_report']}">
                                    Save Export to Report:
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="schedule.save_to_report" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.save_to_report']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.save_to_report']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="schedule.schedule_type === 'Weekly'">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.day_of_week'], 'text-muted-no': !errors['schedules.'+i+'.day_of_week']}">
                                    Day of Week: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="schedule.day_of_week" size="sm" :options="dayOfWeek" :class="{'is-invalid': errors['schedules.'+i+'.day_of_week']}" />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.day_of_week']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.day_of_week']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="schedule.schedule_type === 'Monthly' || schedule.schedule_type === 'Yearly'">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.day_of_month'], 'text-muted-no': !errors['schedules.'+i+'.day_of_month']}">
                                    Day of Month: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-input type="number" v-model="schedule.day_of_month" size="sm" min="1" max="31" :class="{'is-invalid': errors['schedules.'+i+'.day_of_month']}" placeholder="Enter Day of the Month, 1-31." />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.day_of_month']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.day_of_month']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="schedule.schedule_type === 'Yearly'">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.month_of_year'], 'text-muted-no': !errors['schedules.'+i+'.month_of_year']}">
                                    Month: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-lg-6 col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="schedule.month_of_year" size="sm" :options="monthOfYear" :class="{'is-invalid': errors['schedules.'+i+'.month_of_year']}" />

                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.month_of_year']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.month_of_year']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <hr/>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.recipients']}">
                                    User Recipients:
                                </div>
                                <div class="col-lg-6 col-md-8 col-12">
                                    <b-input-group>
                                        <select v-model="user_recip" :class="{'form-control form-control-sm': true, 'is-invalid': errors['schedules.'+i+'.recipients']}">
                                            <option v-for="option in userOptions" :value="option.value">{{ option.text }}</option>
                                        </select>
                                        <b-input-group-append>
                                            <b-button variant="info" v-on:click="addUserRecip(i)" size="sm"><i class="fa fa-plus-circle"></i> Add</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div class="mt-3">
                                        <ul class="list-unstyled">
                                            <li v-for="(user, j) in schedule.users">
                                                <button type="button" class="btn btn-xs btn-default" v-on:click="removeUserRecip(i, j)"><i class="fa fa-trash text-danger"></i></button>
                                                {{ user.last_name }},  {{ user.first_name }} (<a :href="`mailto:${user.email}`">{{ user.email }}</a>)
                                                <label class="badge badge-warning" v-if="user.is_active === 0">Inactive</label>

                                                <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.users.'+j+'.id']">
                                                    <ul class="list-unstyled mb-0">
                                                        <li v-for="err in errors['schedules.'+i+'.users.'+j+'.id']">{{ err }}</li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.recipients']}">
                                    Email Recipients:
                                </div>
                                <div class="col-lg-6 col-md-8 col-12">
                                    <b-input-group>
                                        <b-form-input
                                            ref="emailRecip"
                                            v-model="email_recip"
                                            size="sm"
                                            :class="{'is-invalid': errors['schedules.'+i+'.recipients']}"
                                            placeholder="Enter Email Address" />
                                            <b-input-group-append>
                                                <b-button variant="info" v-on:click="addEmailRecip(i)" size="sm"><i class="fa fa-plus-circle"></i> Add</b-button>
                                            </b-input-group-append>
                                    </b-input-group>

                                    <div class="mt-3">
                                        <ul class="list-unstyled">
                                            <li v-for="(email, j) in schedule.emails">
                                                <button type="button" class="btn btn-xs btn-default" v-on:click="removeEmailRecip(i, j)"><i class="fa fa-trash text-danger"></i></button>
                                                <a :href="`mailto:${email.email_address}`">{{ email.email_address }}</a>

                                                <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.emails.'+j+'.email_address']">
                                                    <ul class="list-unstyled mb-0">
                                                        <li v-for="err in errors['schedules.'+i+'.emails.'+j+'.email_address']">{{ err }}</li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['schedules.'+i+'.recipients']}"></div>
                                <div class="col-lg-6 col-md-8 col-12">
                                    <div class="text-danger mt-1" v-if="errors['schedules.'+i+'.recipients']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['schedules.'+i+'.recipients']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cursor-hover" style="border: 1px dashed #ccc; padding: 3px 5px; text-align: center; font-size: 12px; background: #ffffff;" v-on:click="addSchedule()">
                        <i class="fa fa-plus-circle text-success"></i> Add Report Schedule
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveReportSchedules()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Save Schedules</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                report: {},
                errors: {},
                schedules: [],
                users: [],
                user_recip: null,
                email_recip: null,
            }
        },

        computed: {
            scheduleTypeOptions(){
                //Setup
                return [
                    {value: null, text: '-- Select Frequency --'},
                    {value: 'Daily', text: 'Daily'},
                    {value: 'Weekly', text: 'Weekly'},
                    {value: 'Monthly', text: 'Monthly'},
                    {value: 'Yearly', text: 'Yearly'},
                ];
            },

            dayOfWeek(){
                //Setup
                return [
                    {value: null, text: '-- Select Weekday --'},
                    {value: 0, text: 'Sunday'},
                    {value: 1, text: 'Monday'},
                    {value: 2, text: 'Tuesday'},
                    {value: 3, text: 'Wednesday'},
                    {value: 4, text: 'Thursday'},
                    {value: 5, text: 'Friday'},
                    {value: 6, text: 'Saturday'},
                ];
            },

            monthOfYear(){
                //Setup
                return [
                    {value: null, text: '-- Select Month --'},
                    {value: 0, text: 'January'},
                    {value: 1, text: 'February'},
                    {value: 2, text: 'March'},
                    {value: 3, text: 'April'},
                    {value: 4, text: 'May'},
                    {value: 5, text: 'June'},
                    {value: 6, text: 'July'},
                    {value: 7, text: 'August'},
                    {value: 8, text: 'September'},
                    {value: 9, text: 'October'},
                    {value: 10, text: 'November'},
                    {value: 11, text: 'December'},
                ];
            },

            timezoneOptions(){
                //Setup
                return [
                    {value: 'UTC', text: 'UTC'},
                    {value: 'America/New_York', text: 'America/New_York'},
                    {value: 'America/Chicago', text: 'America/Chicago'},
                    {value: 'America/Denver', text: 'America/Denver'},
                    {value: 'America/Phoenix', text: 'America/Phoenix'},
                    {value: 'America/Los_Angeles', text: 'America/Los_Angeles'},
                    {value: 'America/Anchorage', text: 'America/Anchorage'},
                    {value: 'Pacific/Honolulu', text: 'Pacific/Honolulu'},
                ];
            },

            userOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a User --'}];

                //Loopo
                for (var i = 0; i < this.users.length; i++)
                {
                    options.push({value: this.users[i].id, text: this.users[i].last_name+', '+this.users[i].first_name+' ('+this.users[i].email+')'});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getReportSchedules(){
                //Send it
                this.$http.get('/reports/schedules/' + this.id)
                    .then(response => {
                        //Set the product
                        this.report = response.data.report;
                        this.schedules = response.data.schedules;
                        this.users = response.data.users;

                        //Check for eptyh
                        if(this.schedules.length === 0)
                        {
                            this.addSchedule();
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveReportSchedules(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .post('/reports/schedules/' + this.id, {schedules: this.schedules})
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Report Schedules Updated');

                    //Return to main list?
                    this.$router.push('/reports/view/' + this.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Report Schedules');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            addSchedule(){
                //Push it
                this.schedules.push({
                    report_id: this.report.id,
                    schedule_type: null,
                    schedule_time: null,
                    timezone: this.$root.timezone,
                    is_active: 1,
                    day_of_month: null,
                    day_of_week: null,
                    month_of_year: null,
                    emails: [],
                    users: [],
                });
            },

            removeSchedule(i){
                //Confirm?
                if(!confirm('Are you sure you want to remove this new schedule?'))
                {
                    return;
                }

                //Do what?
                this.schedules.splice(i, 1);
            },

            addUserRecip(i){
                //Check the value
                if(!this.user_recip || this.user_recip == '')
                {
                   //Validaiton
                   this.$toastr.w('Select a User Recipient');

                   //Stop
                   return;
                }

                //setup
                if(!this.schedules[i].users)
                {
                   //Instantiate
                   this.schedules[i].users = [];
                }

                //Build the user payload
                var user = null;

                //Loop and Find
                for (var j = 0; j < this.users.length; j++)
                {
                    if(this.users[j].id === this.user_recip)
                    {
                        //Set the user
                        user = this.users[j];
                    }
                }

                //Push
                if(user)
                {
                    //Append
                    this.schedules[i].users.push(user);
                }

                //reset
                this.user_recip = null;
            },

            removeUserRecip(i, j){
                //Confirm
                if(!confirm('Are you sure you want to remove this user recipient?'))
                {
                    return;
                }

                //Splice
                this.schedules[i].users.splice(j, 1);
            },

            addEmailRecip(i){
                //Check the value
                if(!this.email_recip || this.email_recip == '')
                {
                    //Validaiton
                    this.$toastr.w('Enter an Email Address Recipient');

                    //Stop
                    return;
                }

                //setup
                if(!this.schedules[i].emails)
                {
                    //Instantiate
                    this.schedules[i].emails = [];
                }

                //Push
                this.schedules[i].emails.push({email_address: this.email_recip});

                //reset
                this.email_recip = null;
            },

            removeEmailRecip(i, j){
                //Confirm
                if(!confirm('Are you sure you want to remove this email recipient?'))
                {
                    return;
                }

                //Splice
                this.schedules[i].emails.splice(j, 1);
            },
        },

        mounted() {
            //Get the Product
            this.getReportSchedules();
        }
    }
</script>
